import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { useActionState, useEffect } from "react";
import { deleteGreetingMembership } from "../actions";
import toast from "react-hot-toast";

export function CreateGreetingMembership() {
  return (
    <Link to="/admin/greeting-memberships/create">
      <Button className="mt-4">
        Create Greeting Membership
        <Icon icon={PlusIcon} label="Create Greeting Membership" className="ml-1" />
      </Button>
    </Link>
  );
}

export function UpdateGreetingMembership({ id }: { id: string }) {
  return (
    <Link to={`/admin/greeting-memberships/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteGreetingMembership({ id }: { id: string }) {
  const navigate = useNavigate();
  const deleteWithId = deleteGreetingMembership.bind(null, id);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this greeting membership?")) {
      e.preventDefault();
    }
  }

  const [state, formAction, isPending] = useActionState(deleteWithId, {
    success: false,
  });

  useEffect(() => {
    if (state.success) {
      navigate("/admin/greeting-memberships?reload=true", { replace: true });
      toast.success("Greeting membership deleted successfully");
    }
  }, [state, navigate]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending} />
    </form>
  );
}
